<template>
  <common
    :searchFrom="searchFrom"
    :tableTitle="tableTitle"
    :list="list"
    @crudClick="crudClick"
    :total="total"
    :arrPageSize="arrPageSize"
    :pageSize="searchFrom.pageSize"
    :BoolModal="isshowModal"
    :title="titleModal"
    @changeBindModal="changeBindModal"
    @closedeleteModal="closedeleteModal"
    :unChange="unChange"
    :footerHide="footerHide"
    :width="width"
    :loading="loading"
    :maskClosable="maskClosable"
    :current.sync="current"
    @pageClick="getList"
    ref="common"
    ><template slot="select">
      <FormItem>
        <Select
          v-model="searchFrom.warehouse_id"
          filterable
          clearable
          placeholder="Please Select Warehouse"
        >
          <Option
            v-for="item in warehouseList"
            :value="item.id"
            :key="item.id"
            >{{ item.code }}</Option
          >
        </Select>
      </FormItem>
      <FormItem>
        <Select
          v-model="searchFrom.status"
          filterable
          clearable
          placeholder="Please Select Status"
        >
          <Option
            v-for="item in statusList"
            :value="item.val"
            :key="item.val"
            >{{ item[$i18n.locale] }}</Option
          >
        </Select>
      </FormItem>
      <FormItem>
        <Select
          v-model="searchFrom.is_board"
          filterable
          clearable
          placeholder="Please Select IsBoard"
        >
          <Option v-for="item in boardList" :value="item" :key="item">{{
            item
          }}</Option>
        </Select>
      </FormItem>
    </template>
    <div slot="content">
      <template v-if="crudText == 'delete' || crudText == 'statistics'">
        <p>{{ $t("titleModal") }}</p>
      </template>
      <template v-if="crudText == 'show'">
        <bag-table :tableDetails="tableDetails" v-if="showModal"></bag-table>
      </template>
      <template v-if="crudText == 'operation'">
        <Form
          label-position="right"
          :model="dataDetails"
          :label-width="100"
          :rules="ruleFrom"
          ref="dataDetails"
        >
          <FormItem :label="$t('order_number')" prop="airwayBillNumber">
            <Input
              v-model.trim="dataDetails.airwayBillNumber"
              type="textarea"
              :rows="10"
              placeholder="Please Enter CnbNumber"
            ></Input>
          </FormItem>
          <FormItem :label="$t('type')" prop="type">
            <Select
              v-model="dataDetails.type"
              filterable
              :disabled="disabled"
              placeholder="Please Select Type"
            >
              <Option
                v-for="item in typeList"
                :value="item.val"
                :key="item.val"
                >{{ item[$i18n.locale] }}</Option
              >
            </Select>
          </FormItem>
        </Form>
      </template>
    </div>
  </common>
</template>

<script>
import { getBag, getDetails, postStatist, postMoveCnb } from "@/api/bag/list";
import common from "_c/common-body";
import boxMes from "@/utils/message";
import bagTable from "_my/bag-table";
import { getWarehouse } from "@/api/storage/warehouse";

export default {
  name: "bagList",
  components: {
    common,
    bagTable,
  },
  data() {
    return {
      current: 1,
      arrPageSize: [15, 30, 50, 100],
      maskClosable: false,
      loading: true,
      width: 600,
      list: [],
      searchFrom: {
        page: 1,
        pageSize: 15,
        keywords: "",
        is_board: "",
        status: "",
        warehouse_id: "",
      },
      // Warehouse总数据
      total: 0,
      // 详情模态框显示/隐藏
      isshowModal: false,
      // 数据详情
      dataDetails: {},
      // 删除模态显示/隐藏
      Delmodal1: false,
      // 模态框标题
      isshowModalTitle: "",
      disabled: false,
      ruleFrom: {
        airwayBillNumber: [
          {
            required: true,
            message: "cnbNumer cannot be empty",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            type: "string",
            message: "Please select the type",
            trigger: "change",
          },
        ],
      },
      footerHide: false,
      crudText: "",
      titleModal: "",
      deleteModal: false,
      delId: 0,
      preForm: {},
      unChange: true,
      dateTime: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tableDetails: [],
      typeList: [
        { "zh-CN": "移入该订单", "en-US": "Move in the order", val: "IN" },
        { "zh-CN": "移出该订单", "en-US": "Remove the order", val: "OUT" },
      ],
      statusList: {
        unProcessed: { "zh-CN": "未处理", "en-US": "Unprocessed", val: 2 },
        processed: { "zh-CN": "已处理", "en-US": "Processed", val: 1 },
      },
      boardList: ["YES", "NO"],
      warehouseList: [],
      showModal: false,
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("bagCode"),
        key: "package_number",
        align: "center",
        minWidth: 200,
        tooltip: true,
      });
      columns.push({
        title: this.$t("exlType"),
        key: "status",
        align: "center",
        minWidth: 130,
        tooltip: true,
        render: (h, params) => {
          return h("div", [
            h(
              params.row.is_board == "YES" ? "Button" : "span",
              {
                props: {
                  type: "dashed",
                  size: "small",
                },
                style: {
                  color:
                    params.row.is_board == "YES"
                      ? params.row.volume_size > 0
                        ? "#19be6b"
                        : "#ed4014"
                      : "",
                },
              },
              params.row.is_board == "YES"
                ? params.row.volume_size > 0
                  ? this.statusList.processed[this.$i18n.locale]
                  : this.statusList.unProcessed[this.$i18n.locale]
                : " / "
            ),
          ]);
        },
      });
      columns.push({
        title: this.$t("warehouseCode"),
        key: "warehouse_code",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      // columns.push({
      //   title: this.$t("channel_name"),
      //   key: "channel",
      //   align: "center",
      //   minWidth: 120,
      //   tooltip: true,
      // });
      columns.push({
        title: this.$t("status_operator"),
        key: "operator_title",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      // columns.push({
      //   title: this.$t("createTime"),
      //   key: "create_time",
      //   align: "center",
      //   minWidth: 170,
      // });
      columns.push({
        title: this.$t("invoicePCS"),
        key: "order_count",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      columns.push({
        title: this.$t("invoiceWeight"),
        key: "order_weight",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      columns.push({
        title: this.$t("skuLength"),
        key: "length",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      columns.push({
        title: this.$t("skuWidth"),
        key: "width",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      columns.push({
        title: this.$t("skuHeight"),
        key: "height",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      columns.push({
        title: this.$t("skuVolume"),
        key: "volume_size",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      columns.push({
        title: this.$t("is_board"),
        key: "is_board",
        align: "center",
        minWidth: 100,
        tooltip: true,
      });
      columns.push({
        title: this.$t("operation"),
        slot: "bagOperation",
        align: "center",
        minWidth: 350,
        className: "operation-td",
      });
      return columns;
    },
  },
  mounted() {
    this.getOtherList();
    this.getList(this.searchFrom);
  },
  methods: {
    getOtherList() {
      getWarehouse().then((res) => {
        this.warehouseList = res.data.payload.rows;
      });
    },

    changeBindModal(val) {
      if (!val) {
        this.closedeleteModal(false);
      } else {
        if (this.crudText == "statistics") {
          postStatist({ packageId: this.delId }).then((res) => {
            boxMes.alertMes(res, this);
          });
        } else {
          this.confirm("dataDetails");
        }
      }
    },
    closedeleteModal(e) {
      if (e === false) {
        this.isshowModal = false;
        this.showModal = false;
        this.tableDetails = [];
        if (this.crudText == "operation") {
          this.$refs["dataDetails"].resetFields();
        }
      }
    },
    confirm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = {
            airwayBillNumber: this.dataDetails.airwayBillNumber.split(/\s+/),
            packageId: this.delId,
            type: this.dataDetails.type,
          };
          postMoveCnb(data).then((res) => {
            boxMes.alertMes(res, this);
          });
        } else {
          console.log(this.dataDetails);
        }
      });
    },
    crudClick(item, text) {
      this.titleModal = this.$t(text);
      this.maskClosable = false;
      this.width = 300;
      this.footerHide = false;
      this.unChange = false;
      this.disabled = false;
      this.delId = item.package_number;
      this.maskClosable = true;
      if (item !== 0) {
        if (text === "show") {
          this.width = 1150;
          this.disabled = true;
          this.footerHide = true;
          this.showModal = true;
          this.getDetailsList(item.package_number);
        } else {
          if (text == "operation") {
            this.width = 500;
            this.maskClosable = false;
          }
        }
      }
      this.isshowModal = true;
      this.crudText = text;
    },
    getDetailsList(id) {
      getDetails(id)
        .then((res) => {
          this.tableDetails = res.data.payload.airwayBillNumber;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getList(data) {
      this.loading = true;
      getBag(data)
        .then((res) => {if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.list = res.data.payload.rows.map((item) => {
            item.warehouse_code = item.warehouse ? item.warehouse.code : " / ";
            item.operator_title = item.staff ? item.staff.account : " / ";
            return item;
          });
          this.total = res.data.payload.total;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteList(id) {
      del(id).then((res) => {
        boxMes.alertMes(res, this);
      });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
</style>
